module.exports = __webpack_public_path__ + "static/media/menu-3.e203a8d0.png";